import React from "react";
import "./index.scss";
import { BASE_URL } from "config/config";
import { getFileName } from "helpers/getFileNameFromPath";
import FileUploadIcon from "@mui/icons-material/FileUpload";

const FileUploader = ({
  label = "Choisir un fichier",
  file,
  setFile,
  accept = ".pdf,.jpg,.png",
  id,
  isUpdate = false,
  existingFile = null,
  path,
  isLeft,
}) => {
  function getImageURL(id) {
    return `${BASE_URL}documentsFile/${id}/file`;
  }
  return (
    <div className="file-upload">
      <div
        className="file-label-container"
        style={{ alignItems: isLeft ? "flex-start" : "center" }}>
        <label htmlFor={id} className="file-label">
          <FileUploadIcon />
          {file ? file.name : label}
        </label>

        {isUpdate && existingFile && (
          <a
            href={getImageURL(path?._id)}
            target="_blank"
            rel="noopener noreferrer"
            className="file-link">
            🔗 Voir {path?.title}
          </a>
        )}
      </div>

      <input
        id={id}
        type="file"
        accept={accept}
        className="file-input"
        onChange={(e) => setFile(e.target.files[0])}
      />
    </div>
  );
};

export default FileUploader;
